import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import MainPageManager from "../../components/pageManager/MainPageManager";

const NewsManagerPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <MainPageManager />
                </div>
            </div>
        </div>
    );
};

export default NewsManagerPage;
